import React, { Component } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';
import { observer, inject } from 'mobx-react';
import OverTimeMonthModel from '../static/OverTimeMonthModel';
import OvertimeMonthStateStore from '../stores/OvertimeMonthStateStore';
import commonStore from '../../common/stores/CommonStore';
import { FormattedMessage } from 'react-intl';

interface Props {
  overtimeMonthStateStore?: OvertimeMonthStateStore;
  commonStore?: commonStore;
  overTimeMonthList?: OverTimeMonthModel[];
  date?: OverTimeMonthModel | null;
}

const overTimeRegOtColor = 'rgb(123,124,180)';
const overTimeRegAbColor = 'rgb(119,161,111)';
const overTimeRegInputNColor = 'rgb(241,243,242)';
const overTimeRegGrayColor = 'rgb(189,190,194)';
const overTimeRegWhiteColor = 'white';

const CalendarCellBg = (overtime: any): any => {
  if (overtime.inputYn === 'N') {
    return overTimeRegInputNColor;
  }
  if (overtime.apprSts === 'A') {
    return overTimeRegWhiteColor;
  }
  if (overtime.apprSts === 'S' && overtime.overTimeType === 'OT') {
    return overTimeRegOtColor;
  }
  if (overtime.apprSts === 'S' && overtime.overTimeType === 'AB') {
    return overTimeRegAbColor;
  }
  if (overtime.apprSts === 'R') {
    return overTimeRegGrayColor;
  }
  return overTimeRegWhiteColor;
};

const CalendarCellColor = (overtime: any): any => {
  if (overtime.leaveYn != null) {
    return 'black';
  }
  if (overtime.reducYn != null) {
    return 'black';
  }
  if (overtime.apprSts === undefined) {
    return overTimeRegGrayColor;
  }
  if (overtime.apprSts === 'A' && overtime.overTimeType === 'OT') {
    return overTimeRegOtColor;
  }
  if (overtime.apprSts === 'A' && overtime.overTimeType === 'AB') {
    return overTimeRegAbColor;
  }
  if (overtime.apprSts === 'S' && overtime.overTimeType === 'OT') {
    return overTimeRegWhiteColor;
  }
  if (overtime.apprSts === 'S' && overtime.overTimeType === 'AB') {
    return overTimeRegWhiteColor;
  }
  if (overtime.apprSts === 'R') {
    return overTimeRegWhiteColor;
  }
  return overTimeRegGrayColor;
};

const CalendarCell = styled.div<{ overtime?: any }>`
  background-color: ${(props: any): any => CalendarCellBg(props.overtime)};
  border-bottom: 1px solid rgb(209, 211, 212);
  height: 125px;
  min-width: 150px;
  padding: 2px 2px 0 2px;
  display: table-cell;
  color: ${(props: any): any => CalendarCellColor(props.overtime)};
`;

const CalendarCellNoAppr = styled.div<{ overtime?: any }>`
  background-color: ${(props: any): any => CalendarCellBg(props.overtime)};
  border-bottom: 1px solid rgb(209, 211, 212);
  height: 100px;
  min-width: 150px;
  padding: 2px 2px 0 2px;
  display: table-cell;
  vertical-align: top;
  color: ${(props: any): any => CalendarCellColor(props.overtime)};
`;

const CalendarWeeklyCell = styled.div<{ displayRate?: number }>`
  border-bottom: 1px solid rgb(209, 211, 212);
  border-right: 1px solid rgb(209, 211, 212);
  height: 100px;
  padding: 2px 2px 0 2px;
  display: table-cell;
  font-size: 15px;
  font-weight: 700;
  vertical-align: middle;
  text-align: center;
`;

const CalendarEmptyCell = styled.div`
  border: 1px solid #dddddd;
  background-color: #f5f5f5;
  min-width: 150px;
  height: 80px;
  padding: 0;
  display: table-cell;
`;

const CellContentsHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CellContentsDate = styled.div<{ holiday?: string }>`
  color: ${(props: any): any => contentsDateColorChooser(props.holiday)};
  padding: 2px 5px;
  font-size: 15px;
  font-weight: 700;
`;

const cellContentsApprColor = (overtime: any): any => {
  if (overtime.apprSts === 'S') {
    return overTimeRegWhiteColor;
  }
  if (overtime.apprSts === 'R') {
    return overTimeRegWhiteColor;
  }
  return 'black';
};

const CellContentsAppr = styled.div<{ overtime?: any }>`
  color: ${(props: any): any => cellContentsApprColor(props.overtime)};
  padding: 2px 5px;
  font-size: 11px;
  font-weight: 700;
`;

const CellContentsInfo = styled.div<{ apprSts?: any; overTimeType?: any; reduc?: any; leave?: any }>`
  background-color: ffffff00;
  min-height: 27px;
  padding: 2px 2px 0px 5px;
  text-align: left;
  font-size: 13px;
  font-weight: 700;
  border-radius: 12px;
  /* color: black; */
`;

const CellContentsInfoType = styled.div<{ overtime?: any }>`
  /* color: ${(props: any): any => cellContentsTimeColor(props.overtime)}; */
  font-weight: 700;
`;

const cellContentsTimeColor = (overtime: any): any => {
  if (overtime.overTimeType === undefined) {
    return 'black';
  }
  if (overtime.inputYn === 'N') {
    return overTimeRegGrayColor;
  }
  if (overtime.apprSts === 'A' && overtime.overTimeType === 'OT') {
    return overTimeRegOtColor;
  }
  if (overtime.apprSts === 'A' && overtime.overTimeType === 'AB') {
    return overTimeRegAbColor;
  }
  if (overtime.apprSts === 'S') {
    return overTimeRegWhiteColor;
  }
  if (overtime.apprSts === 'R') {
    return overTimeRegWhiteColor;
  }
  return overTimeRegGrayColor;
};

const CellContentsTime = styled.div<{ overtime?: any }>`
  background-color: ffffff00;
  min-height: 27px;
  padding: 2px 2px 0px 5px;
  text-align: center;
  font-size: 35px;
  font-weight: 700;
  border-radius: 12px;
  color: ${(props: any): any => cellContentsTimeColor(props.overtime)};
`;

const CellContentsBody = styled.div`
  display: flex;
  justify-content: space-between;
`;

const contentsDateColorChooser = (holiday: string): string => {
  if (holiday === 'N') {
    return 'black';
  }
  if (holiday === 'Y') {
    return 'red';
  }
  return overTimeRegWhiteColor;
};

@inject('overtimeMonthStateStore')
@inject('commonStore')
@observer
export default class OverTimeCellStateDetailComponent extends Component<Props> {
  // 입력불가능한 근로날짜 생성
  calendarCreateStop = (overtime: OverTimeMonthModel, displayRate: any, displayOvertime: string): JSX.Element => {
    if (overtime.apprSts === '1') {
      const retrunCell = (
        <CalendarCellNoAppr overtime={overtime}>
          <CellContentsHeader>
            <CellContentsDate holiday={overtime.holidayYn}>{overtime.yyyymmdd.substring(6, 8)}</CellContentsDate>
            <CellContentsAppr overtime={overtime}></CellContentsAppr>
          </CellContentsHeader>

          <CellContentsBody>
            <CellContentsInfo apprSts={overtime.apprSts} overTimeType={overtime.overTimeType} reduc={overtime.reducYn} leave={overtime.leaveYn}>
              <CellContentsInfoType overtime={overtime}></CellContentsInfoType>
            </CellContentsInfo>
            <CellContentsTime overtime={overtime}></CellContentsTime>
          </CellContentsBody>
        </CalendarCellNoAppr>
      );

      return retrunCell;
    }
    const retrunCell = (
      <CalendarCellNoAppr overtime={overtime}>
        <CellContentsHeader>
          <CellContentsDate holiday={overtime.holidayYn}>{overtime.yyyymmdd.substring(6, 8)}</CellContentsDate>
          <CellContentsAppr overtime={overtime}>{overtime.apprStsName}</CellContentsAppr>
        </CellContentsHeader>
        <CellContentsBody>
          <CellContentsInfo apprSts={overtime.apprSts} overTimeType={overtime.overTimeType} reduc={overtime.reducYn} leave={overtime.leaveYn}>
            <Tooltip title={this.toolTipTitle(overtime)}>
              <CellContentsInfoType overtime={overtime}>
                {overtime.overTimeType === 'OT' ? (
                  <FormattedMessage id="overtime.calendar.label.overtime.work" />
                ) : overtime.overTimeType === 'AB' ? (
                  <FormattedMessage id="overtime.calendar.label.alternate.break" />
                ) : (
                  <div></div>
                )}
              </CellContentsInfoType>
              {/* <br /> */}
              {overtime.pjName}
            </Tooltip>
          </CellContentsInfo>
          <CellContentsTime overtime={overtime}>{overtime.overtimeWorkHours}</CellContentsTime>
        </CellContentsBody>
      </CalendarCellNoAppr>
    );
    return retrunCell;
  };

  toolTipTitle = (overtime: OverTimeMonthModel): JSX.Element => {
    if (overtime.pjInfo != null) {
      const retrunCell = (
        <div>
          <span>PM : {overtime.pjInfo.pmEmpNm} </span>
          <br />
          <span>PJ : {overtime.pjInfo.pjName} </span>
        </div>
      );
      return retrunCell;
    }

    return <></>;
  };

  calendarEtc = (overtime: OverTimeMonthModel, displayRate: any, displayOvertime: string): JSX.Element => {
    let workhour: any;
    if (overtime.overtimeWorkHours === null || overtime.overtimeWorkHours === 0) {
      workhour = '';
    } else {
      workhour = overtime.overtimeWorkHours;
    }
    const retrunCell = (
      <CalendarCell overtime={overtime}>
        <CellContentsHeader>
          <CellContentsDate holiday={overtime.holidayYn}>{overtime.yyyymmdd.substring(6, 8)}</CellContentsDate>
        </CellContentsHeader>
        <CellContentsBody>
          <CellContentsInfo apprSts={overtime.apprSts} overTimeType={overtime.overTimeType} reduc={overtime.reducYn} leave={overtime.leaveYn}>
            <CellContentsInfoType overtime={overtime}>
              {overtime.reducYn != null ? (
                <FormattedMessage id="overtime.calendar.label.short.work" />
              ) : overtime.leaveYn != null ? (
                <FormattedMessage id="overtime.calendar.label.vacation" />
              ) : (
                <div></div>
              )}
            </CellContentsInfoType>
          </CellContentsInfo>
        </CellContentsBody>
      </CalendarCell>
    );
    return retrunCell;
  };

  renderCell = (overtime: OverTimeMonthModel): JSX.Element => {
    if (overtime == null) {
      return <CalendarEmptyCell />;
    }

    let displayOvertime: string;
    if (overtime.overTimeType === 'H') {
      displayOvertime = `${overtime.workSysMonthWeekly} `;

      return (
        <CalendarWeeklyCell>
          {displayOvertime}
          <FormattedMessage id="overtime.calendar.label.week" />
        </CalendarWeeklyCell>
      );
    }
    if (overtime.reducYn !== null) {
      displayOvertime = `단축근무`;
      return this.calendarEtc(overtime, null, displayOvertime);
    }
    if (overtime.leaveYn !== null) {
      displayOvertime = `휴가`;
      return this.calendarEtc(overtime, null, displayOvertime);
    }
    if (overtime.apprSts === null || overtime.apprSts === '1') {
      displayOvertime = '';

      return this.calendarCreateStop(overtime, null, displayOvertime);
    }
    if (overtime.overTimeType === 'OT') {
      displayOvertime = `연장근로`;
      return this.calendarCreateStop(overtime, 0, displayOvertime);
    }
    if (overtime.overTimeType === 'AB') {
      displayOvertime = `대체휴식`;
      return this.calendarCreateStop(overtime, 100, displayOvertime);
    }

    displayOvertime = '';
    return this.calendarCreateStop(overtime, null, displayOvertime);
  };

  render(): JSX.Element {
    const date = this.props.date!;
    // const overTimeMonthList = this.props.overTimeMonthList!;

    return <>{this.renderCell(date)}</>;
  }
}
